import './js/preloader';
import './js/footer-modal';
import './js/local-storage';
import './js/dark-light';
import './js/modalMovieLibrary';
import './js/showing-trailer';
